/**
 * Global JavaScript entry point
 *
 * @package Felix
 */

import '../shared/index.js'
import './cookies'
import { initAnimations } from './animate.js'
import { initMobileMenu } from './mobile-menu.js'
import { initMegamenu } from './megamenu.js'
import { initTracking } from './tracking.js'
import { setupClampToggles } from '../shared/clamp-toggle.js'
import { initLazyVideos, initReducedMotionVideos } from './lazy-video.js'
import { initMarquees } from './marquee.js'

// Initialize mobile menu
initMobileMenu()

// Initialize megamenu
initMegamenu()

// Initialize custom tracking utilities
initTracking()

// Initialize reusable line-clamp toggles (Show more / Show less)
setupClampToggles()

// Drop sources on motion-averse videos before the lazy observer can hydrate them
initReducedMotionVideos()

// Defer below-the-fold video source loading
initLazyVideos()

// Fill marquee tracks with enough set clones to cover the viewport
initMarquees()

// Expose APIs to window if needed
window.FelixGlobal = {
	...window.FelixGlobal,
	animations: {
		init: initAnimations,
	},
	clampToggles: {
		init: setupClampToggles,
	},
	lazyVideos: {
		init: initLazyVideos,
	},
	reducedMotionVideos: {
		init: initReducedMotionVideos,
	},
}
